import { render } from "./JourneyIndex.vue?vue&type=template&id=0c327262"
import script from "./JourneyIndex.vue?vue&type=script&lang=js"
export * from "./JourneyIndex.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__